import { addIntersectionItem } from '../util'

let el

let topBand = 0.98
let bottomBand = 0.6
let bandDiff = topBand - bottomBand

export function ScrollFade() {
    el = document.querySelector('.js-hero')
    if (!el) {
        return
    }

    addIntersectionItem(el, handleIntersection)
}

function handleIntersection({ el }, entry) {
    let opacity = 1

    if (!entry.isIntersecting) {
        opacity = 0
    } else {
        if (entry.intersectionRatio >= bottomBand && entry.intersectionRatio <= topBand) {
            opacity = 1 - (1 - entry.intersectionRatio) / bandDiff
        } else if (entry.intersectionRatio < bottomBand) {
            opacity = 0
        }
    }

    el.style.setProperty('--hero-opacity', opacity)
}
